/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Same_AllInputs */

const en_us2_profile_editors_same_all = /** @type {(inputs: Profile_Editors_Same_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, always the same`)
};

const pt_br2_profile_editors_same_all = /** @type {(inputs: Profile_Editors_Same_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, sempre os mesmos`)
};

const es_419_profile_editors_same_all = /** @type {(inputs: Profile_Editors_Same_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, siempre los mismos`)
};

const pt_pt2_profile_editors_same_all = /** @type {(inputs: Profile_Editors_Same_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, sempre os mesmos`)
};

const fr_fr2_profile_editors_same_all = /** @type {(inputs: Profile_Editors_Same_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, toujours les mêmes`)
};

const de_de2_profile_editors_same_all = /** @type {(inputs: Profile_Editors_Same_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, immer dieselben`)
};

const it_it2_profile_editors_same_all = /** @type {(inputs: Profile_Editors_Same_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, sempre gli stessi`)
};

/**
* | output |
* | --- |
* | "Yes, always the same" |
*
* @param {Profile_Editors_Same_AllInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_same_all = /** @type {((inputs?: Profile_Editors_Same_AllInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Same_AllInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_same_all(inputs)
	if (locale === "es-419") return es_419_profile_editors_same_all(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_same_all(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_same_all(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_same_all(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_same_all(inputs)
	return en_us2_profile_editors_same_all(inputs)
});
export { profile_editors_same_all as "profile-editors.same_all" }